import './Library.css';
import LatestNewsMarquee from './Partials/LatestNewsMarquee';
import StickyNav from './Partials/StickyNav';
import WorkingHoursCard from './Partials/WorkingHoursCard';
import AboutSection from './Partials/AboutSection';
import ServicesSection from './Partials/ServicesSection';
import RepositorySection from './Partials/RepositorySection';
import MembershipSection from './Partials/MembershipSection';
import NewsEventsSection from './Partials/NewsEventsSection';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';

const toArray = (val) => (Array.isArray(val) ? val : []);

const Library = () => {
  const location = useLocation();

  const [banner, setBanner] = useState({
    title: '',
    images: [],
    mobile_images: []
  });

  // Fetch banner
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await api.get("/api/sitepages/about-us/library");
        setBanner(res.data.banner_data || {});
      } catch (error) {
        console.error("Banner loading error:", error);
      }
    };

    fetchBanner();
  }, []);

  // Smooth scroll for hash
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="library-page">

    <DynamicBanner
  title={banner.title || 'Library Policy'}
  bgImage={toArray(banner.images)}
  bgImageMobile={toArray(banner.mobile_images)}
/>


      <WorkingHoursCard />
      <LatestNewsMarquee />
      <StickyNav />
      <AboutSection />
      <ServicesSection />
      <MembershipSection />
      <RepositorySection />
      <NewsEventsSection />
    </div>
  );
};

export default Library;
